import React, {SetStateAction, Suspense} from 'react';

import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import {DialogActions, Theme} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";

import BaseDataContent from "../DetailsContent/BaseDataContent";
import FadeInDetailsContent from "./FadeInDetailsContent";
import {IMAGE_FILETYPES} from "../../../Utils/const";
import {BaseDataType} from "../types";
import FullScreenImage from "./FullScreenImage";

type FullscreenDialogProps = {
    openFullScreen: boolean
    closeFullscreen: () => void
    baseData: BaseDataType
    recruitEmail: string
    fileType: string
    rotationInDrawer: number
    setRotationInDrawer: React.Dispatch<SetStateAction<number>>
    fileData: string;
    mandate: number;
}

const FullscreenDialog: React.FC<FullscreenDialogProps> = (props) => {

    const {
        openFullScreen,
        closeFullscreen,
        baseData,
        recruitEmail,
        fileType,
        rotationInDrawer,
        setRotationInDrawer,
        fileData="",
        mandate,
    } = props;

    const [scrollTarget, setScrollTarget] = React.useState< Node | Window | undefined>(undefined)

    return (
        <Dialog open={openFullScreen} onClose={closeFullscreen} fullScreen>
            <DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={closeFullscreen}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 3,
                        color: (theme: Theme) => theme.palette.grey[500]
                    }}
                >
                    <CloseIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent ref={(node: any) => {
                if (node) {
                    setScrollTarget(node);
                }
            }}>
                <Box sx={{display: "flex", flexDirection: "column"}}>

                    <Box sx={{
                        backgroundColor: (theme: Theme) => theme.palette.grey[200],
                        padding: "2px",
                        mb: "2px",
                        borderRadius: "5px",
                        width: "auto",
                        position: "sticky"
                    }}>
                        <BaseDataContent baseData={baseData} recruitEmail={recruitEmail} mandate={mandate}/>
                    </Box>
                    <FadeInDetailsContent target={scrollTarget} baseData={baseData} recruitEmail={recruitEmail} mandate={mandate}/>
                    {IMAGE_FILETYPES.includes(fileType) ?
                        <Suspense fallback={<CircularProgress />}>
                            <FullScreenImage fileData={fileData} rotationInDrawer={rotationInDrawer} setRotationInDrawer={setRotationInDrawer}/>
                        </Suspense>:
                        <Box sx={{height: "100vh", width: "100%", position: "relative"}}>
                            <iframe src={fileData}
                                    style={{height: "100%", position: "absolute", width: "100%",  zIndex: 1}}
                                    title={new Date().getTime() + ""}/>
                        </Box>
                    }
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="text" onClick={closeFullscreen}>Schließen</Button>
            </DialogActions>
        </Dialog>
    );
};

export default FullscreenDialog;